/** A registry of all the global composables in our application */

import type { GlobalComposable } from "~/classes/composable/GlobalComposable"

interface State {
  registry: Record<string, GlobalComposable<any>>
}

let state: Ref<State>

function defaultState(): State {
  return {
    registry: {},
  }
}

function registerGlobalComposable(composable: GlobalComposable<any>) {
  if (state.value.registry[composable.name])
    return composable
  state.value.registry[composable.name] = composable
  composable.onCreate()
  return composable
}

function createGlobalRegistry() {
  registerGlobalComposable(useSelf())
  registerGlobalComposable(useSelection())
  registerGlobalComposable(useFolderNotes())
  registerGlobalComposable(useSearch())
  registerGlobalComposable(useAgent())
  registerGlobalComposable(useNavigation())
  registerGlobalComposable(useClipboard())
  registerGlobalComposable(usePanel())
  registerGlobalComposable(usePreview())
  registerGlobalComposable(useSidebar())
  registerGlobalComposable(useInstantSearch())
  registerGlobalComposable(useViewMode())
  registerGlobalComposable(useSavedUsers())
  registerGlobalComposable(useSharedDrives())
  registerGlobalComposable(useCollectionView())
  registerGlobalComposable(useJobs())
  registerGlobalComposable(useNotificationTray())
  registerGlobalComposable(useAlerts())
  registerGlobalComposable(useGestures())
  registerGlobalComposable(useMocks())
  registerGlobalComposable(useAuthentication())
  registerGlobalComposable(useConversations())
  registerGlobalComposable(useOnboarding())
  registerGlobalComposable(useGalleryView())
  registerGlobalComposable(useColumnView())
  registerGlobalComposable(useTreeView())
  registerGlobalComposable(useTableView())
  registerGlobalComposable(useIconView())
  registerGlobalComposable(useGridView())
  registerGlobalComposable(useDetailView())
  registerGlobalComposable(useFeedView())
}

function clearGlobalRegistryState() {
  for (const composable of Object.values(state.value.registry))
    composable.clearState()
}

function destroyGlobalRegistry() {
  for (const composable of Object.values(state.value.registry)) {
    composable.onDestroy()
    composable.clearState()
  }
  state.value = defaultState()
}

function resetGlobalRegistry() {
  destroyGlobalRegistry()
  createGlobalRegistry()
}

export default function () {
  state = useState("global-registry-state", defaultState)

  return {
    globalRegistryState: state,
    createGlobalRegistry,
    clearGlobalRegistryState,
    destroyGlobalRegistry,
    resetGlobalRegistry,
    registerGlobalComposable,
  }
}
